import { css } from 'styled-components'

// TYPES

export enum FontWeights {
  thin = 100,
  extraLight = 200,
  light = 300,
  regular = 400,
  medium = 500,
  semiBold = 600,
  bold = 700,
  extraBold = 800,
  black = 900,
}

export enum FontStyles {
  normal = 'normal',
  italic = 'italic',
  oblique = 'oblique',
}

type Font = {
  basename: string
  fontFamily: string
  fontWeight?: FontWeights
  fontStyle?: FontStyles
  fallback?: string
}

enum FontKeys {
  UniversRoman = 'UniversRoman',
  UniversCondensed = 'UniversCondensed',
  UniversBoldCondensed = 'UniversBoldCondensed',
  BBCond = 'BBCond',
  BBCondBold = 'BBCondBold',
  BBRegular = 'BBRegular',
}

// DECLARATIONS

export const declarations: { [key in FontKeys]: Font } = {
  UniversRoman: {
    basename: 'UniversLTCYR-55Roman',
    fontFamily: 'UniversLTCYR-55Roman',
    fontWeight: FontWeights.regular,
    fontStyle: FontStyles.normal,
    fallback: 'Arial, Helvetica, sans-serif',
  },
  UniversCondensed: {
    basename: 'UniversLTCYR-57Condensed',
    fontFamily: 'UniversLTCYR-57Condensed',
    fontStyle: FontStyles.normal,
    fontWeight: FontWeights.regular,
    fallback: 'Arial, Helvetica, sans-serif',
  },
  UniversBoldCondensed: {
    basename: 'UniversLTCYR-67BoldCond',
    fontFamily: 'UniversLTCYR-67BoldCond',
    fontStyle: FontStyles.normal,
    fontWeight: FontWeights.regular,
    fallback: 'Arial, Helvetica, sans-serif',
  },
  BBCond: {
    basename: 'BB-Cond',
    fontFamily: 'BB-Cond',
    fontStyle: FontStyles.normal,
    fontWeight: FontWeights.regular,
    fallback: 'Arial, Helvetica, sans-serif',
  },
  BBCondBold: {
    basename: 'BB-CondBold',
    fontFamily: 'BB-CondBold',
    fontStyle: FontStyles.normal,
    fontWeight: FontWeights.regular,
    fallback: 'Arial, Helvetica, sans-serif',
  },
  BBRegular: {
    basename: 'BB-Regular',
    fontFamily: 'BB-Regular',
    fontStyle: FontStyles.normal,
    fontWeight: FontWeights.regular,
    fallback: 'Arial, Helvetica, sans-serif',
  },
}

// @FONT-FACE

export const fontsFaces: any[] = Object.values(declarations)?.map(
  (declaration) => css`
    @font-face {
      font-family: ${declaration.fontFamily};
      font-display: swap;
      font-weight: ${declaration.fontWeight || FontWeights.regular};
      font-style: ${declaration.fontStyle || FontStyles.normal};
      src: url('/fonts/${declaration.basename}/${declaration.basename}.woff2') format('woff2');
    }
  `
)

// CSS

const fontCSS = (font: Font): string => `
    font-family: "${font.fontFamily}", ${font.fallback || 'sans-serif'};
    font-weight: ${font.fontWeight || FontWeights.regular};
    font-style: ${font.fontStyle || FontStyles.normal};
  `

const fonts: { [key in FontKeys]: string } = Object.keys(declarations)?.reduce(
  (acc, fontKey) => ({
    ...acc,
    [fontKey]: fontCSS(declarations[fontKey as FontKeys]),
  }),
  {} as any
)

export default fonts
